/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const monetario_input = (valorString: string) => {
    // Remove tudo que não é dígito
    const apenasDigitos = valorString.replace(/\D/g, '');

    // Se vazio, retorna 0
    if (apenasDigitos === '') return 0;

    // Converte para número (os dígitos representam centavos)
    return parseInt(apenasDigitos, 10) / 100;
};

export const monetario_output = (valor: number | null | undefined) => {
    if (!valor && valor !== 0) return '';

    return valor.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};